module.exports = __webpack_public_path__ + "img/blueprint.73c83a7f.png";